import { render, staticRenderFns } from "./DirectViewerButton.vue?vue&type=template&id=eb0f15e6&scoped=true&"
import script from "./DirectViewerButton.vue?vue&type=script&lang=js&"
export * from "./DirectViewerButton.vue?vue&type=script&lang=js&"
import style0 from "./DirectViewerButton.vue?vue&type=style&index=0&id=eb0f15e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0f15e6",
  null
  
)

export default component.exports